import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@repo/ui/components/dropdown-menu";
import { ChevronDown } from '@repo/ui/components/icon'
import { Button } from "@repo/ui/components/button";
import { useTranslation } from 'react-i18next';
import { useLocation, useRouteLoaderData } from 'react-router';
import { Language, supportedLanguages } from '~/localization/resource';
import { type loader as rootLoader } from '~/root'
import { Link } from './link';
import { useState } from 'react';
import { Icon, IconName } from './ui/icon';


const image_locale: Record<Language, IconName> = {
  vi: 'VN',
  en: 'GB'
}

function LanguageSwitcher() {
  const data = useRouteLoaderData<typeof rootLoader>("root");
  const { i18n } = useTranslation();
  const location = useLocation();
  const [locale, setLocale] = useState<Language>(data?.locale || "vi");

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button className='bg-brand-50 rounded-lg text-black min-w-[85px]' variant="secondary">
          <Icon name={image_locale[locale]} className='text-2xl' />
          {locale.toUpperCase()}
          <ChevronDown />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent>
        {supportedLanguages.map((lang) => {
          return (
            <DropdownMenuItem key={lang} asChild>
              <Link
                to={`${location.pathname}`}
                keepSearchParams
                language={lang}
                onClick={() => {
                  setLocale(lang);
                  i18n.changeLanguage(lang);
                }}
              >
                <Icon name={image_locale[lang]} />
                {lang.toUpperCase()}
              </Link>
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default LanguageSwitcher;
